import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const routeMeta = {
  "/": {
    title: "1ACT Driving School | Trusted Drivers Education Program",
    description:
      "Join 1ACT's drivers education program to learn safe driving skills. State-approved courses with expert instructors for teens and adults. Enroll today!",
    canonical: "https://www.1statlantaduischool.com/",
  },
  "/schedule-driving-lessons-2": {
    title: "Behind the Wheel Driving School – Certified Driver Lessons",
    description:
      "Join a trusted behind the wheel driving school offering expert training for teens and adults. Enroll today to start safe, confident, and certified driving lessons.",
    canonical: "https://www.1statlantaduischool.com/schedule-driving-lessons-2",
  },
  "/drivers-education": {
    title: "Joshua's Law Online Course – Start Driving in Georgia",
    description:
      "Joshua's Law course in Atlanta – state-approved driver's education for teens. Get your license fast with expert instruction. Enroll online today!",
    canonical: "https://www.1statlantaduischool.com/drivers-education",
  },
  "/online-drivers-education": {
    title: "Driver Education Online Course – Georgia DDS Approved",
    description:
      "Complete your Georgia driver education online course. DDS-approved 30-hour course for teens and adults. Study anytime, anywhere.",
    canonical: "https://www.1statlantaduischool.com/online-drivers-education",
  },
  "/gdec-scholarship": {
    title: "GDEC Scholarship – Free Georgia Driver’s Ed Course",
    description:
      "Apply now for the GDEC Scholarship – Georgia Driver’s Education Grant covering your 30‑hour classroom + 6‑hour behind‑the‑wheel course at approved schools.",
    canonical: "https://www.1statlantaduischool.com/gdec-scholarship",
  },
  "/road-test-services": {
    title: "Georgia Driving Road Test Services | 1st Atlanta DUI School",
    description:
      "Schedule your Georgia driving road test with ease. Licensed examiners, real testing cars, and flexible slots. Book now at 1st Atlanta DUI School",
    canonical: "https://www.1statlantaduischool.com/road-test-services",
  },
  "/defensive-driving-at-location": {
    title: "Defensive Driving Course – Build Safer Driving Habits",
    description:
      "Join our defensive driving course to improve awareness, reduce accident risk, and even save on insurance. Trusted defensive driving school for all drivers.",
    canonical:
      "https://www.1statlantaduischool.com/defensive-driving-at-location",
  },
  "/defensive-driving-course-remote": {
    title: "Defensive Driving Course Online - Learn at Your Pace",
    description:
      "Join our online defensive driving class and boost your road skills. Learn stress-free, meet court or job needs, and qualify for potential insurance discounts.",
    canonical:
      "https://www.1statlantaduischool.com/defensive-driving-at-location",
  },
  "/dui-risk-reduction-at-location": {
    title: "DUI Course – Court-Approved Risk Reduction Program",
    description:
      "Complete your court-approved DUI driving course with 1ACT Driving School. Flexible classes, expert guidance, and license restoration support",
    canonical:
      "https://www.1statlantaduischool.com/dui-risk-reduction-course-remote",
  },
  "/dui-risk-reduction-course-remote": {
    title: "DUI Online Course – Fast, Private & Court-Approved Program",
    description:
      "Complete your DUI course online with a certified provider. Flexible, private, and meets court or DMV requirements. Start today to take control of your driving future",
    canonical:
      "https://www.1statlantaduischool.com/dui-risk-reduction-course-remote",
  },
  "/clinical-evaluation": {
    title: "Clinical Evaluation for DUI | 1st Atlanta DUI School",
    description:
      "Need a clinical evaluation for DUI in Georgia? State-approved, confidential assessments by certified professionals. Book your appointment today",
    canonical: "https://www.1statlantaduischool.com/clinical-evaluation",
  },
  "/victim-impact-panel": {
    title: "Victim Impact Panel | 1st Atlanta DUI School",
    description:
      "Attend a state-approved victim impact panel. Fulfill court or DDS requirements with 1st Atlanta DUI School.",
    canonical: "https://www.1statlantaduischool.com/victim-impact-panel",
  },
  "/our-locations": {
    title: "1 ACT Driving School Location Near You in Georgia",
    description:
      "Explore 1 ACT Driving School locations across Georgia. Convenient, state-certified driver’s ed and DUI classes near you. Find your nearest location today.",
    canonical: "https://www.1statlantaduischool.com/our-locations",
  },
};

const DynamicMeta = () => {
  const location = useLocation();

  let cleanedPathname = location.pathname.replace(/\/$/, "");
  if (cleanedPathname === "") cleanedPathname = "/"; // Handle root path

  console.log("DynamicMeta location:", cleanedPathname);

  const meta = routeMeta[cleanedPathname];

  const DESCRIPTION = meta?.description || "";
  console.log(location.pathname, meta, DESCRIPTION);

  if (!meta) return null;
  return (
    <Helmet
      onChangeClientState={() => {
        const metaDescription = document.querySelector(
          'meta[name="description"]'
        );
        if (metaDescription) {
          metaDescription.setAttribute("content", DESCRIPTION);
        }
      }}
    >
      <title>{meta.title}</title>
      <meta name="description" content={meta.description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={meta.canonical} />
    </Helmet>
  );
};

export default DynamicMeta;
